import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from "./appCardDefault";
import { DomHelper } from "./domHelper";
import { getShopBackendData } from "./xhrbackend";
function renderContent(cardNode, username, bearerToken, injectNode, medProId = -1) {
    if (medProId == -1)
        medProId = Number(DomHelper.getSearchParam(window.location.href, 'id'));
    getShopBackendData("", `/medpro/${medProId}`, "GET", "application/json", bearerToken, function (response) {
        const formNode = injectNode.querySelector('.rudi-form-input-group');
        if (formNode)
            formNode.classList.add('disabled');
        const productResponseData = JSON.parse(response.target.response);
        const medProData = productResponseData.items[0];
        const medProDataNode = DomHelper.appendNode(injectNode, 'div', ['rudi-medpro-data']);
        DomHelper.appendNode(medProDataNode, 'div', [], [], `Typ: ${medProData.type}`);
        DomHelper.appendNode(medProDataNode, 'div', [], [], `Hersteller: ${medProData.manufacturer}`);
        DomHelper.appendNode(medProDataNode, 'div', [], [], `Klient: ${medProData.klient}`);
        cardNode.classList.add('app-open');
        cardNode.classList.add('rudi-col-span-2');
        cardNode.classList.remove('rudi-max-height');
        DomHelper.appendCloseSection(cardNode, (event) => {
            cardNode.classList.remove('app-open');
            cardNode.classList.remove('rudi-col-span-2');
            cardNode.classList.add('rudi-max-height');
            medProDataNode.remove();
            if (formNode) {
                formNode.classList.remove('disabled');
            }
        });
    });
}
export function appDeskMedpro(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appDeskMedpro");
    const additionalClassList = [];
    const idString = 'rudi-medpro';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, (event) => {
        const injectNode = cardNode.querySelector(`#${idString}`);
        if (injectNode) {
            renderContent(cardNode, username, bearerToken, injectNode, -1);
        }
    });
    const injectNode = cardNode.querySelector('.rudi-app-inject');
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
        const inputNode = DomHelper.appendInputText(injectNode, 'rudi-medpro-form', ['rudi-inline-icon'], [], 'medproid', '', '', []);
        const btnNode = DomHelper.appendNodeAsSibling(inputNode, 'button', ['btn', 'btn-primary'], []);
        DomHelper.appendNode(btnNode, 'i', ['fa-light', 'fa-paper-plane'], []);
        btnNode.addEventListener('click', (event) => {
            if (DEBUG)
                console.log('medpro clicked');
            let inputValue = inputNode.value;
            if (inputValue) {
                renderContent(cardNode, username, bearerToken, injectNode, Number(inputValue));
            }
        });
        inputNode.addEventListener('keypress', (event) => {
            if (event.key == 'Enter') {
                let usernameIMP = inputNode.value;
            }
        });
    }
}
